import http from './http';

export async function createCheckoutSession(clientId, planId) {
  const res = await http.post('/stripe/checkout', { clientId, planId });
  return res.data?.data ?? res.data; // handles { data: { url } } or { url }
}
